import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllKodeAkunDropdown = createAsyncThunk(
  "kodeAkun/GetAllKodeAkunDropdown",
  async (token, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/kodeakun`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllKodeAkun = createAsyncThunk(
  "kodeAkun/GetAllKodeAkun",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/kodeakun/all?${data.url}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleKodeAkun = createAsyncThunk(
  "kodeAkun/GetSingleKodeAkun",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/kodeakun/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const kodeAkunSlice = createSlice({
  name: "kodeAkun",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all kodeAkun for dropdown
    builder.addCase(GetAllKodeAkunDropdown.pending, loadingHandler);
    builder.addCase(GetAllKodeAkunDropdown.fulfilled, fulfilledHandler);
    builder.addCase(GetAllKodeAkunDropdown.rejected, rejectedHandler);
    // get all kodeAkun
    builder.addCase(GetAllKodeAkun.pending, loadingHandler);
    builder.addCase(GetAllKodeAkun.fulfilled, fulfilledHandler);
    builder.addCase(GetAllKodeAkun.rejected, rejectedHandler);
    // get single kodeAkun
    builder.addCase(GetSingleKodeAkun.pending, loadingHandler);
    builder.addCase(GetSingleKodeAkun.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleKodeAkun.rejected, rejectedHandler);
  },
});

export const { reset } = kodeAkunSlice.actions;
export default kodeAkunSlice.reducer;
